import { EntityType } from '../../../@types/entityTypes';
import { IDocumentConfig, ReportOutputType, ReportType } from '../../schema/p4types';
import GeneratePurchaseLedgerAllocationAuditReportMutation from '../../mutations/supplier/GeneratePurchaseLedgerAllocationAuditReportMutation.graphql';

export enum PurchaseAllocationAction {
  AllocationAuditReport = 'PURCHASE_ALLOCATION_AUDIT_REPORT',
}

const PurchaseAllocationAuditReport: EntityType = {
  type: 'PurchaseAllocationAuditReport',
  title: 'Purchase Allocation Audit Report',
  screenReference: PurchaseAllocationAction.AllocationAuditReport,
  generate: GeneratePurchaseLedgerAllocationAuditReportMutation,
  configuration: {
    defaultConfig: {
      output: ReportOutputType.LocalPrinter,
    },
    field: undefined as unknown as keyof IDocumentConfig, //There's no defaults configurable for purchase allocation audit report, so cheating a bit here.
    title: 'Purchase Allocation Audit Report',
    reportType: ReportType.AllocationAuditReport,
  },
};

export default PurchaseAllocationAuditReport;
